<template>
  <PaymentMethodIcons
    :icons="paymentMethodIcons"
  />
</template>

<script lang="ts">

import PaymentMethodIcons from '~/components/atoms/Payment/PaymentMethodIcons.vue';
import type { PaymentMethodIcon } from '~~/types/cms/PaymentIcons';

export default defineComponent({
  name: 'TrustedPayments',
  components: {
    PaymentMethodIcons,
  },
  props: {
    paymentMethodIcons: {
      type: Array as PropType<PaymentMethodIcon[]>,
      required: true,
    },
  },
});
</script>
